import { useEffect, useState } from 'react';
import { PaymentDetailModal } from '../../components/PaymentDetailModal';
import { PageHead, ListTable, BankCell, StatusPill, ActBtn } from '../../components/list';
import { paymentsApi, type PaymentSummary } from '../../api/payments';
import { money, dCell } from '../../components/format';
import '../page.css';

export function PaymentHistory() {
  const [rows, setRows] = useState<PaymentSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [detailOrder, setDetailOrder] = useState<string | null>(null);

  useEffect(() => {
    paymentsApi.mine().then(setRows).catch(() => setError('Ödemeler yüklenemedi'));
  }, []);

  return (
    <div className="page">
      <PageHead eyebrow="Tahsilat" title="Ödemelerim" sub="Geçmiş ödemelerinizi ve durumlarını görüntüleyin." />
      {error && <div className="auth-error">{error}</div>}
      {rows && (
        <ListTable
          storageKey="bayi-payments"
          head={[
            { label: 'Tarih', width: 120 },
            { label: 'Sipariş No', width: 230 },
            { label: 'Banka', width: 200 },
            { label: 'Tutar', width: 130, right: true },
            { label: 'Taksit', width: 120 },
            { label: 'Durum', width: 130 },
            { label: 'İşlem', width: 100, right: true },
          ]}
          empty={rows.length === 0 ? <div className="lt-empty">Henüz ödeme kaydınız yok.</div> : undefined}
        >
          {rows.map((p) => {
            const d = dCell(p.createdAt);
            return (
              <tr key={p.orderId}>
                <td><div className="lt-date">{d.date}<small>{d.time}</small></div></td>
                <td className="lt-oid" title={p.orderId}>{p.orderId}</td>
                <td><BankCell bankKey={p.bankKey} /></td>
                <td className="lt-amt">{money(p.amount)}</td>
                <td>{p.installment === 1 ? 'Tek Çekim' : `${p.installment} Taksit`}</td>
                <td><StatusPill status={p.status} /></td>
                <td>
                  <div className="lt-acts">
                    <ActBtn icon="view" title="Detay" onClick={() => setDetailOrder(p.orderId)} />
                    {p.status === 'approved' && (
                      <ActBtn icon="download" title="Dekont (PDF)" href={`/api/payments/${encodeURIComponent(p.orderId)}/dekont`} />
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </ListTable>
      )}

      <PaymentDetailModal orderId={detailOrder} onClose={() => setDetailOrder(null)} />
    </div>
  );
}
